export default "__VITE_ASSET__C32X_PQr__";